import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, ArrowLeft, KeyRound } from 'lucide-react'; // Importamos iconos para apoyo visual
import logo from '../../assets/logo.png';
import { useUsuarioCreacionModel } from '../../modelos/Usuario/modeloUsuario';

const RecuperarContrasena = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);

    const navigate = useNavigate();
    const { generateCambioContrasena } = useUsuarioCreacionModel();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccessMessage(null);

        try {
            await generateCambioContrasena(email);
            setSuccessMessage('Te hemos enviado un correo con instrucciones para recuperar tu contraseña.');
        } catch (error) {
            setError("No pudimos procesar la solicitud. Verifica el correo.");
        } finally {
            setLoading(false);
        }
    };

    const handleBackToLogin = () => navigate('/login');

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-logo">
                    <img src={logo} alt="Logo" />
                </div>

                <div style={{ marginBottom: '25px' }}>
                    <h2 style={{ marginBottom: '8px' }}>Recuperar Contraseña</h2>
                    <div style={{ width: '40px', height: '3px', backgroundColor: '#003366', margin: '0 auto', borderRadius: '2px' }}></div>
                </div>

                {error && <div className="error-message">{error}</div>}
                {successMessage && (
                    <div className="success-message" style={{ backgroundColor: '#e6fffa', color: '#236969', padding: '15px', borderRadius: '8px', fontSize: '14px', marginBottom: '20px' }}>
                        {successMessage}
                        <p style={{ fontSize: '12px', marginTop: '10px', opacity: 0.8 }}>No olvides revisar tu carpeta de correos no deseados (Spam).</p>
                    </div>
                )}

                {!successMessage ? (
                    <form onSubmit={handleSubmit}>
                        {/* --- SECCIÓN MEJORADA: CORREO ELECTRÓNICO --- */}
                        <div className="form-group" style={{ textAlign: 'left', marginBottom: '25px' }}>
                            <label htmlFor="email" style={{ fontWeight: '700', fontSize: '13px', color: '#4a5568', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px', display: 'block' }}>
                                Correo electrónico
                            </label>
                            
                            <p style={{ fontSize: '13px', color: '#718096', lineHeight: '1.5', marginBottom: '15px' }}>
                                Ingresa tu dirección de correo y te enviaremos un enlace seguro para restablecer tu acceso.
                            </p>

                            <div style={{ position: 'relative' }}>
                                <Mail 
                                    size={18} 
                                    style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#a0aec0' }} 
                                />
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="nombre@ejemplo.com"
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '12px 12px 12px 40px', // Espacio para el icono
                                        borderRadius: '8px',
                                        border: '1px solid #e2e8f0',
                                        fontSize: '15px',
                                        boxSizing: 'border-box',
                                        outline: 'none',
                                        transition: 'border-color 0.2s'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#003366'}
                                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                                />
                            </div>
                        </div>
                        {/* ------------------------------------------- */}

                        <button type="submit" className="login-button" disabled={loading}>
                            {loading ? 'Enviando...' : 'Enviar instrucciones'}
                        </button>
                    </form>
                ) : (
                    <button onClick={handleBackToLogin} className="login-button" type="button">
                        Volver a Iniciar Sesión
                    </button>
                )}

                <button onClick={handleBackToLogin} className="team-link" type="button" style={{ marginTop: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', width: '100%', background: 'none', border: 'none', color: '#718096', cursor: 'pointer' }}>
                    <ArrowLeft size={14} /> Volver
                </button>

                <div className="version-container">
                    <span className="version">v1.8.6</span>
                </div>
            </div>
        </div>
    );
};

export default RecuperarContrasena;